import React from 'react';

import { FormTabsContext } from '../_context';

export const useFormTabsContext = () => React.useContext(FormTabsContext);
